
import { Card, CardContent } from "@/components/ui/card";

interface DashboardStatsCardsProps {
  articleCount: number;
}

const DashboardStatsCards = ({ articleCount }: DashboardStatsCardsProps) => (
  <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4 mb-8">
    <Card>
      <CardContent className="pt-5">
        <div className="text-2xl font-bold">{articleCount}</div>
        <p className="text-sm font-medium text-muted-foreground">Total Articles</p>
      </CardContent>
    </Card>
    <Card>
      <CardContent className="pt-5">
        <div className="text-2xl font-bold">1,024</div>
        <p className="text-sm font-medium text-muted-foreground">Registered Users</p>
      </CardContent>
    </Card>
    <Card>
      <CardContent className="pt-5">
        <div className="text-2xl font-bold">512</div>
        <p className="text-sm font-medium text-muted-foreground">Premium Subscribers</p>
      </CardContent>
    </Card>
    <Card>
      <CardContent className="pt-5">
        <div className="text-2xl font-bold">24.3K</div>
        <p className="text-sm font-medium text-muted-foreground">Monthly Page Views</p>
      </CardContent>
    </Card>
  </div>
);

export default DashboardStatsCards;
